import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../../components/header/Header';
import Footer from '../../../components/footer/Footer';
import HeroCarousel from '../../../components/carousel/HeroCarousel';
import img1 from '../../../assets/StudentPerformance.webp';
import Breadcrumb from '../../../shared/components/Breadcrumb';

const HolisticLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <HeroCarousel images={[img1]} autoRotateInterval={3000} />
      <div className="w-full max-w-[1600px] mx-auto px-4">
        <Breadcrumb />
      </div>
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default HolisticLayout;
